<template>
  <tr>
    <th>유효 기간</th>
    <td>
      <PeriodPicker
        class="type_fl"
        :minDate="new Date()"
        :maxDate="$utils.calcDate(null, '1y')"
        :startDate="from_local"
        :endDate="to_local"
        @change="onChangePicker"
        ref="periodPicker"
      />
      <p class="caution type_fl">
        <span class="ico">*</span> 1년 이내
      </p>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    from: {
      type: [String, Date],
      default: () => new Date()
    },
    to: {
      type: [String, Date],
      default() {
        return this.$utils.calcDate(null, "1y");
      }
    }
  },
  data() {
    return {
      from_local: new Date(this.from),
      to_local: new Date(this.to)
    };
  },
  watch: {
    from_local(val) {
      this.$emit("update:from", this.$utils.timeText(val, true));
    },
    to_local(val) {
      this.$emit("update:to", this.$utils.timeText(val, true));
    }
  },
  methods: {
    onChangePicker() {
      const pickerData = this.$refs.periodPicker.getData();
      this.from_local = pickerData.startDate;
      this.to_local = pickerData.endDate;
    }
  },
  mounted() {
    this.$emit("update:from", this.$utils.timeText(this.from_local, true));
    this.$emit("update:to", this.$utils.timeText(this.to_local, true));
  }
};
</script>

<style></style>
